module.exports = __webpack_public_path__ + "img/sedena-tools.41093bc7.png";